import { Component, OnInit } from '@angular/core';

import { AlertService } from './alert.service';

import { ALERT } from '../../shared/constants';
import { TranslateService } from 'ng2-translate/ng2-translate';

const KEY_ESC = 27;

@Component({
  moduleId: module.id,
  selector: 'cms-alert',
  templateUrl: 'alert.component.html',
  styleUrls: [
    'alert.component.scss'
  ]
})
export class AlertComponent implements OnInit {
  title: string;
  message: string;
  okText: string;
  cancelText: string;
  preview: boolean;
  previewLogin: boolean;
  negativeOnClick: (e: any) => void;
  positiveOnClick: (e: any) => void;

  image: string;


  private defaults = {
    title: '',
    message: '',
    cancelText: '',
    okText: '',
    image: null,
    preview: false,
    previewLogin: false
  };
  private modalElement: any;
  private cancelButton: any;
  private okButton: any;

  constructor(alertService: AlertService,
    private translator: TranslateService,
  ) {
    this.translateMessages();
    alertService.activate = this.activate.bind(this);
  }



  activate(
    message = this.defaults.message,
    title = this.defaults.title,
    okText = this.defaults.okText,
    cancelText = this.defaults.cancelText,
    image = this.defaults.image,
    preview = this.defaults.preview,
    previewLogin = this.defaults.previewLogin
  ) {
    this.title = title;
    this.message = message;
    this.okText = okText;
    this.cancelText = cancelText;
    this.image = image;
    this.preview = preview;
    this.previewLogin = previewLogin;

    let promise = new Promise<boolean>((resolve, reject) => {
      this.negativeOnClick = (e: any) => resolve(false);
      this.positiveOnClick = (e: any) => resolve(true);
      this.show();
    });

    return promise;
  }

  ngOnInit() {
    this.modalElement = document.getElementById('confirmationModal');
    this.cancelButton = document.getElementById('cancelButton');
    this.okButton = document.getElementById('okButton');
  }

  translateMessages(){
   this.translator.get('modal').subscribe((res) => {
      this.defaults.message = res.alert['confirm-message'];
      this.defaults.okText = res.alert['confirm-ok'];
      this.defaults.cancelText = res.alert['cancel'];
   })
  }

  private show() {
    document.onkeyup = null;

    if (!this.modalElement || !this.cancelButton || !this.okButton) {
      return;
    }

    this.modalElement.style.opacity = -1;
    this.modalElement.style.zIndex = 9999;

    this.cancelButton.onclick = ((e: any) => {
      e.preventDefault();
      if (!this.negativeOnClick(e)) {
        this.hideDialog();
      }
    });

    this.okButton.onclick = ((e: any) => {
      e.preventDefault();
      if (!this.positiveOnClick(e)) {
        this.hideDialog();
      }
    });

    this.modalElement.onclick = () => {
      this.hideDialog();
      return this.negativeOnClick(null);
    };

    document.onkeyup = (e: any) => {
      if (e.which === KEY_ESC) {
        this.hideDialog();
        return this.negativeOnClick(null);
      }
    };

    this.modalElement.style.opacity = 1;
  }

  private hideDialog() {
    document.onkeyup = null;
    this.modalElement.style.opacity = 0;
    window.setTimeout(() => this.modalElement.style.zIndex = -1, 400);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/alert/alert.component.ts